<template>
  <v-menu offset-y open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon>
        <v-icon small>mdi-information-outline</v-icon>
      </v-btn>
    </template>
    <div class="px-3 py-2 bg-white">
      <p class="ma-0 font-13 text-gray-100 my-1">Transferência de mercadoria</p>

      <template v-for="(item, index) in OUTRAS_FILIAIS">
        <div
          v-if="item.consumo_medio_mensal_auxiliar > 0"
          :key="index"
          class="font-13 pb-1 pl-2"
        >
          {{ `${formatarNumero(calcularDistribuicaoFilial(item))}` }}
          {{ EMBALAGEM_MASTER_ATIVA ? item.unidade_master : item.unidade_compra }}
          {{ `para a filial ${item.filial}` }}
        </div>
      </template>
    </div>
  </v-menu>
</template>

<script>
import {formatarValor} from "@/helpers";

export default {
  name: "SugestaoDistribuicao",
  props: {
    itens: {
      type: Array,
      default: () => ([])
    },
    consumo_medio_total: Number,
    filial_origem: Object
  },
  computed: {
    OUTRAS_FILIAIS() {
      return this.itens.filter(item => item.filial !== this.filial_origem.filial);
    },
    SUGESTAO_TRANSFERENCIA_TOTAL() {
      const callback = (a,  b) => (a + Number(b.sugestao_transferencia));
      return this.itens.reduce(callback, 0);
    },
    CONSUMO_MEDIO_OUTRAS_FILIAIS() {
      return this.consumo_medio_total - this.filial_origem.consumo_medio_mensal_auxiliar;
    },
    EMBALAGEM_MASTER_ATIVA() {
      return this.$store.getters['EmbalagemTelaDeCompras/getEmbalagemMaster'];
    },
  },
  methods: {
    formatarNumero: formatarValor,
    calcularDistribuicaoFilial(item) {
      return ((Number(item.consumo_medio_mensal_auxiliar) / this.CONSUMO_MEDIO_OUTRAS_FILIAIS) * this.filial_origem.sugestao_transferencia);
    }
  }
}
</script>

<style scoped>

</style>
